import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import DataTable from 'base/components/table/DataTable/index';
import MainTitle from 'base/components/MainTitle/index';
import Header from 'base/components/Header/index';
import { DashboardIcon, AddIcon } from 'base/components/Icon/index';
import theme from 'theme/theme';
import Button from 'base/components/Button/index';
import ButtonGroup from 'base/components/ButtonGroup/index';
import { getDeleteColumn, getEditColumn } from 'base/components/table/RowActionButton';
import { fetchAllSpacesForAllFolderTrees, fetchAllSpaces } from 'spaces/store/actions';
import { openModal } from '../../../modal';
import {
  fetchAllDefaultDashboards,
  setActiveDefaultDashboardId,
  getAllDefaultDashboards,
} from '../../../dashboard';


class ManageDefaultDashboards extends React.Component {
  componentDidMount() {
    const {
      fetchAllDefaultDashboards, fetchAllSpacesForAllFolderTrees, fetchAllSpaces,
    } = this.props;
    fetchAllDefaultDashboards();
    fetchAllSpacesForAllFolderTrees();
    fetchAllSpaces();
  }

  handleEdit = (data) => {
    const { setActiveDefaultDashboardId, openModal } = this.props;
    setActiveDefaultDashboardId(data.id);
    openModal('DASHBOARD_EDIT_MODAL');
  };

  handleDelete = (data) => {
    const { setActiveDefaultDashboardId, openModal } = this.props;
    setActiveDefaultDashboardId(data.id);
    openModal('DASHBOARD_DELETE_MODAL');
  };

  render() {
    const { dashboards, openModal } = this.props;

    const columns = [
      {
        Header: 'Name',
        accessor: 'name',
        showOnMobile: true,
      },
      getEditColumn(this.handleEdit),
      getDeleteColumn(this.handleDelete),
    ];

    return (
      <>
        <Header>
          <MainTitle>
            <DashboardIcon />
            {' '}
Manage default dashboards
          </MainTitle>
          <ButtonGroup pullRight>
            <Button onClick={() => openModal('DASHBOARD_CREATE_MODAL')}>
              <AddIcon color={theme.colors.medium} />
              {' '}
New dashboard
            </Button>
          </ButtonGroup>
        </Header>
        <DataTable
          data={dashboards}
          columns={columns}
        />
      </>
    );
  }
}
ManageDefaultDashboards.propTypes = {
  dashboards: PropTypes.arrayOf(PropTypes.object).isRequired,
  fetchAllDefaultDashboards: PropTypes.func.isRequired,
  openModal: PropTypes.func.isRequired,
  setActiveDefaultDashboardId: PropTypes.func.isRequired,
  fetchAllSpacesForAllFolderTrees: PropTypes.func.isRequired,
  fetchAllSpaces: PropTypes.func.isRequired,
};


const mapStateToProps = (state) => ({
  dashboards: getAllDefaultDashboards(state),
});

const mapDispatchToProps = {
  fetchAllDefaultDashboards,
  openModal,
  setActiveDefaultDashboardId,
  fetchAllSpacesForAllFolderTrees,
  fetchAllSpaces,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ManageDefaultDashboards);
